function rewriteToFixed(num, n) {
	const result =
		parseInt(Math.abs(num) * Math.pow(10, n) + 0.5) / Math.pow(10, n)
	return num >= 0 ? result : -result
}

export default rewriteToFixed
window.rewriteToFixed = rewriteToFixed
